import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { grey } from '@mui/material/colors';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import { Table } from '@mui/material';
import { TimeSignalAttribute } from 'graphql/types';
import { useScrollbarStyles } from 'modules/common/styles';
import NoteAttribute from './NoteAttribute';

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1, 2),
    background: grey[200],
    height: 'auto',
    maxHeight: 150,
    overflow: 'auto',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    fontSize: theme.typography.subtitle2.fontSize
  }
}));

type NoteAttributesProps = {
  attributes: TimeSignalAttribute[] | undefined;
};

const orderAttributes = (attributes: TimeSignalAttribute[] | undefined) => {
  if (attributes === undefined) return [];
  const visibleAttributes = attributes?.filter((i) => i?.visible);
  const timeStampAttributes = visibleAttributes
    .filter((i) => i.value.type === 'timestamp')
    .sort((a, b) => {
      return (
        (new Date(a.value.value) as any) - (new Date(b.value.value) as any)
      );
    });

  const otherAttributes = visibleAttributes
    .filter((i) => i.value.type !== 'timestamp')
    .sort(
      (a, b) => new Blob([a.value.value]).size - new Blob([b.value.value]).size
    );
  return [...timeStampAttributes, ...otherAttributes];
};

export const NoteAttributes: React.FC<NoteAttributesProps> = ({
  attributes
}: NoteAttributesProps) => {
  const classes = useStyles();
  const classesScrollbar = useScrollbarStyles();

  const orderedAtrributes = orderAttributes(attributes);
  return (
    <>
      <div
        data-testid="note-attributes-details"
        className={classnames(classes.root, classesScrollbar.scrollbar)}
      >
        {orderedAtrributes.length === 0 ? (
          <FormattedMessage id="note.attributes.notFound" />
        ) : (
          <Table>
            {orderedAtrributes.map((a) => {
              return <NoteAttribute key={a.name} attribute={a} />;
            })}
          </Table>
        )}
      </div>
    </>
  );
};
